'use client';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import useMixPanel from '@/hooks/useMixPanel';
import { useRootStore } from '@/providers/root-store-provider';
import { DialogClose } from '@radix-ui/react-dialog';
import { AlertTriangle } from 'lucide-react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const InsuranceWarningModal: React.FC = () => {
  const { t } = useTranslation(['bookings']);
  const Mixpanel = useMixPanel();

  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isInsuranceDataComplete = useRootStore(
    (store) => store.isInsuranceDataComplete
  );
  const isModalOpen = useRootStore((store) => store.isModalOpen);
  const closeModal = useRootStore((store) => store.closeModal);
  const checkModalStatus = useRootStore((store) => store.checkModalStatus);

  // Check modal status on initial load
  useEffect(() => {
    checkModalStatus();
  }, [checkModalStatus]);

  // Check modal status on route change
  useEffect(() => {
    checkModalStatus();
  }, [pathname, searchParams, checkModalStatus]);

  return (
    <Dialog
      open={isModalOpen && !isInsuranceDataComplete}
      onOpenChange={() => closeModal()}
    >
      <DialogContent>
        <DialogHeader>
          <AlertTriangle className="text-red-500" />
          <DialogTitle>{t('insuranceModal.title')}</DialogTitle>
        </DialogHeader>
        <p className="mb-3 ">{t('insuranceModal.description')}</p>

        <DialogFooter>
          <DialogClose
            asChild
            onClick={() => {
              Mixpanel.track('close modal', {
                screen: 'bookings'
              });
              closeModal();
            }}
          >
            <Button variant={'secondary'}>Ok</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InsuranceWarningModal;
